<template>
  <div class="dialog-container wt-dialog-container ">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" ></wt-form-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SiteConsumablesViewTab',
  isAutoComponent: true,
  props: ['siteId'],
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_GOODS',
        formComponent: {
          list: { type: 'default', value: '/modules/site/siteApproveConsumablesList', params: { siteId: '' }}
        },
        formInputsData: [{ name: '申请时间', key: 'dataTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/site/siteApproveConsumablesListImport',
          fileName: '耗材补货' }],
        formTableData: [
          { name: '耗材名称', key: 'name', type: 'text' },
          { name: '申请数量', key: 'count', type: 'text' },
          { name: '发货数量', key: 'countReal', type: 'text' },
          { name: '到货数量', key: 'countCurrent', type: 'text' },
          { name: '申请时间', key: 'createTime', type: 'text' },
          { name: '申请人', key: 'employeesName', type: 'text' },
          { name: '收货人', key: 'operatorName', type: 'text' },
          { name: '收货时间', key: 'operatorTime', type: 'text' },
          { name: '状态', key: 'stateName', type: 'text' }],
        formTableButtonsData: [],
        formResult: { },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      }
    }
  },
  created() {
    this.form.formComponent.list.params.siteId = this.siteId
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {}
  }
}
</script>
